import validators from '../../utils/validators';

class QuestionnaireAnswer {
  /**
   * @param data
   */
  constructor(data) {
    const properties = {
      id: (v) => validators.isNotEmptyString(v),
      userId: (v) => validators.isNotEmptyString(v),
      field: (v) => validators.isNotEmptyString(v),
      value: (v) => validators.isNotEmptyStringOrNull(v),
      comment: (v) => validators.isNotEmptyStringOrNull(v),
    };

    for (const property of Object.keys(properties)) {
      if (properties[property](data[property]) !== true) {
        throw new Error(`Invalid QuestionnaireAnswer property '${property}' in ${data.id}`);
      }

      this[property] = data[property];
    }
  }
}

export default QuestionnaireAnswer;
